import { GetSTSToken } from "../http/entrance";
import { replace } from "../utils/replace"
import { ElMessage, ElLoading } from "element-plus";
var OSS = require('ali-oss');
const client = (stsToken, accessKeyId, accessKeySecret) => {
  var client = new OSS({
    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region: 'oss-cn-beijing',
    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    // 从STS服务获取的安全令牌（SecurityToken）。
    stsToken: stsToken,

    secure: true,
    endpoint: 'oss-cn-beijing.aliyuncs.com',
    // 刷新临时访问凭证的时间间隔，单位为毫秒。
    refreshSTSTokenInterval: 300000,
    // 填写Bucket名称。
    bucket: 'hspublicfileoss'
  })
  return client
}
let aliModel = {
  Model: {},
};
let loading;
let clientOSS;
const multipartUpload = async (file) => {
  loading = ElLoading.service({
    lock: true,
    text: "上传中······",
    background: "rgba(0, 0, 0, 0.7)",
  });
  let path = await GetSTSToken()
    .then((res) => {
      aliModel.Model = res;
      clientOSS = client(aliModel.Model.STSModel.SecurityToken, aliModel.Model.STSModel.AccessKeyId, aliModel.Model.STSModel.AccessKeySecret);
      clientOSS.options.stsToken = aliModel.Model.STSModel.SecurityToken;
      clientOSS.options.accessKeyId = aliModel.Model.STSModel.AccessKeyId;
      clientOSS.options.accessKeySecret =
        aliModel.Model.STSModel.AccessKeySecret;
      return clientOSS
        .multipartUpload(
          aliModel.Model.FilePathName + "/" + aliModel.Model.Guid + file.name,
          file.raw,
          {
            parallel: 4,
            // 设置分片大小。默认值为1 MB，最小值为100 KB。
            partSize: 1024 * 1024,
            meta: { year: 2021, people: "test" },
            mime: file.raw.type
          }
        )
        .then((res) => {
          if (res.name != null && res.name != "") {
            ElMessage({
              message: "上传成功",
              type: "success",
            });
            loading.close();
            return replace("https://hspublicfileoss.oss-cn-beijing.aliyuncs.com/" + res.name);
          }
        })
        .catch((err) => {
          ElMessage.error("上传失败，请重新上传")
          console.log(err)
          loading.close();
        });

    }).catch(err => {
      console.log(err)
      ElMessage.error("服务器错误，请联系管理员")
      loading.close();
      return;
    })
  return path;
}


const signatureUrl = async (path) => {
  let signPath = await GetSTSToken()
    .then(stsTokenOptions => {
      const cli = client(stsTokenOptions.STSModel.SecurityToken, stsTokenOptions.STSModel.AccessKeyId, stsTokenOptions.STSModel.AccessKeySecret);
      return cli.signatureUrl(path, {})
    })
  return signPath;
}
export { multipartUpload, client, signatureUrl }